import { IRouteChild } from '@simac/ui';
import { OrderpickingMoveAssetRoute } from './move-asset/move-asset.routes';
import { OrderpickingMovePalletRoute } from './move-pallet/move-pallet.routes';

export const OrderpickingRoute: IRouteChild[] = [
  {
    title: 'MENU.FIELDSUPPORT.MOVE-ASSET',
    icon: 'far fa-gem',
    route: OrderpickingMoveAssetRoute,
  },
  {
    title: 'MENU.FIELDSUPPORT.MOVE-PALLET',
    icon: 'far fa-pallet-box',
    route: OrderpickingMovePalletRoute,
  },
];
